import { Card, Flex, JanePayLogo, Typography } from '@iheartjane/reefer';
import { formatCurrency } from '@iheartjane/utils';
import { clsx } from 'clsx';

import { DealTag } from '../DealTag/DealTag';
import styles from './PaymentOptionCard.module.css';

export interface PaymentOptionCardProps {
  cashBack?: number | null;
  feeAmount?: number;
  name: string;
  onClick: () => void;
  selected: boolean;
  showCashbackBadge?: boolean;
  showJanePayLogo?: boolean;
  subLabel?: string;
  total: number;
}

export const PaymentOptionCard = ({
  cashBack,
  feeAmount = 0,
  name,
  onClick,
  selected,
  showCashbackBadge = false,
  showJanePayLogo = false,
  subLabel,
  total,
}: PaymentOptionCardProps) => {
  const showFee = feeAmount > 0;
  const showBadge = showCashbackBadge && (cashBack ?? 0) > 0;

  return (
    <Card
      border={selected ? 'primary' : 'transparent-black-ten'}
      borderWidth={selected ? '2px' : '1px'}
      width="100%"
      flat
    >
      <Card.Content
        ariaLabel={`Select ${name}`}
        onClick={onClick}
        p={24}
        className={clsx(styles['paymentButton'], {
          [styles['paymentButton_withBadge']]: showBadge,
        })}
      >
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          gap={4}
          grow={1}
          minWidth={0}
        >
          {showJanePayLogo && (
            <JanePayLogo height={20} data-testid="jane-pay-logo" />
          )}
          <Typography
            variant={showJanePayLogo ? 'mini' : 'body-bold'}
            className={showJanePayLogo ? styles['bankName'] : undefined}
          >
            {name}
          </Typography>
        </Flex>
        <Flex flexDirection="column" alignItems="flex-end" gap={4} shrink={0}>
          <Typography variant="body-bold">{formatCurrency(total)}</Typography>
          {showFee && (
            <Typography variant="mini" color="grays-mid" whiteSpace="nowrap">
              Incl. {formatCurrency(feeAmount)} fee
            </Typography>
          )}
          {showBadge && (
            <DealTag
              tagLabel={`+${formatCurrency(cashBack)} cash back`}
              isGold
              maxLabelLength={20}
            />
          )}
          {subLabel && (
            <Typography variant="mini" color="grays-mid" whiteSpace="nowrap">
              {subLabel}
            </Typography>
          )}
        </Flex>
      </Card.Content>
    </Card>
  );
};
